import React, { useState, useEffect, useRef } from "react";
import { IoIosSearch } from "react-icons/io";
import { LuPlus } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import "./Table.css";
import { CiEdit } from "react-icons/ci";
import axiosInstance from "../axiosinstance";
import { IoCloseOutline } from "react-icons/io5";
import Pagination from "../Components/Pagination";
import { PiSortAscendingThin } from "react-icons/pi";
import { getRoleBadgeClass } from "../helperFunctions";

function SystemUsers({ isSidebarExpanded }) {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]); // State to hold user data
  const [loading, setLoading] = useState(true); // State for loading
  const [error, setError] = useState(null); // State for error handling
  const [searchVisible, setSearchVisible] = useState(false); // Toggle search bar
  const [roles, setRoles] = useState([]);
  const containerRef = useRef(null);
  const [selectedFirms, setSelectedFirms] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [totalRecords, settotalRecords] = useState(1);
  const ITEMS_PER_PAGE = 100;
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(ITEMS_PER_PAGE);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const [searchQuery, setSearchQuery] = useState(""); // Store search input
  const [debouncedSearch, setDebouncedSearch] = useState(""); // Add this line
  const [isSortPopup, setIsSortPopup] = useState(false); // Sort popup state


  useEffect(() => {
      const fetchRoles = async () => {
        try {
          const response = await axiosInstance.get(`/api/get_all_roles`);
  
          if (response.status === 200 && response.data?.data?.length > 0) {
            setRoles(
              response.data.data.map((role) => ({
                value: role.role_id,
                label: role.role_name,
              }))
            );
          }
        } catch (error) {
          console.error("Error fetching roles:", error);
        }
      };
      fetchRoles();
    }, []);
  // Close popup when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsSortPopup(false);
      }
    }

    if (isSortPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSortPopup]);

  const handleCheckboxChange = (userId) => {
    setSelectedFirms((prevSelected) => {
      const updatedSelected = prevSelected.includes(userId)
        ? prevSelected.filter((id) => id !== userId)
        : [...prevSelected, userId];

      return updatedSelected;
    });
  };
  // Handle 'Select All' checkbox change
  const handleSelectAll = () => {
    if (users.length === 0) {
      // If no users, do nothing
      return;
    }

    if (selectAll) {
      setSelectedFirms([]); // Unselect all
    } else {
      setSelectedFirms(users.map((user) => user.user_id)); // Select all user IDs
    }
    setSelectAll(!selectAll);
  };
  // helper to look up the role name
  const getRoleName = (roleId) => {
  const found = roles.find((r) => r.value === roleId);
  return found ? found.label : roleId; // fallback to raw ID if not found
};
  // Update 'Select All' based on selected checkboxes
  useEffect(() => {
    if (users.length > 0) {
      setSelectAll(selectedFirms.length === users.length && users.length > 0);
    } else {
      setSelectAll(false);
    }
  }, [selectedFirms, users]);

  const handleSortpopup = () => {
    setIsSortPopup(!isSortPopup);
  };

  // Fetch users from the API
  // const fetchUsers = async (status = "Active",currentPage,totalRecords) => {
  //   try {
  //     const authKey = localStorage.getItem("authKey"); // Get auth key from localStorage
  //     const apiUrl = `${API_URL}/api/get_all_user_of_firm?page_status=${status}`; // Replace with your API endpoint

  //     const response = await axios.get(apiUrl, {
  //       headers: {
  //         Authorization: `Bearer ${authKey}`,
  //       },
  //       params: {
  //         page: currentPage,
  //         per_page: totalRecords,
  //       },
  //     });

  //     if (response.status === 200) {
  //       setUsers(response.data.data); // Assuming the API returns a `users` array
  //       settotalRecords(response.data.totalRecords)
  //     } else {
  //       setError("Failed to fetch users.");
  //     }
  //   } catch (err) {
  //     console.error("Error fetching users:", err.message);
  //     setError("Error fetching users. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  //   const fetchUsers = async (status = "Active", currentPage, totalRecords) => {
  //     console.log("Fetching Users - Current Page:", currentPage);

  //     try {
  //         const authKey = localStorage.getItem("authKey");
  //         const apiUrl = `${API_URL}/api/get_all_user_of_firm?page_status=${status}`;

  //         const response = await axios.get(apiUrl, {
  //             headers: { Authorization: `Bearer ${authKey}` },
  //             params: {
  //                 page: Math.max(1, currentPage),
  //                 per_page: totalRecords
  //             },
  //         });

  //         console.log("API Response Data:", response.data); // Debugging Log
  //         console.log("API Response totalRecords:", response.data.totalRecords); // Check this

  //         if (response.status === 200) {
  //             setUsers(response.data.data);
  //             settotalRecords(response.data.Total_records || 0); // Avoid NaN
  //         } else {
  //             setError("Failed to fetch users.");
  //         }
  //     } catch (err) {
  //         console.error("Error fetching users:", err.message);
  //         setError("Error fetching users. Please try again.");
  //     } finally {
  //         setLoading(false);
  //     }
  // };

  const fetchUsers = async (
    status = "Active",
    currentPage = 1,
    perPage = ITEMS_PER_PAGE
  ) => {
    console.log("Fetching Users - Current Page:", currentPage);

    try {
      const response = await axiosInstance.get(
        `/api/get_all_user_of_firm?page_status=${status}`,
        {
          params: {
            page: Math.max(1, currentPage),
            per_page: perPage,
          },
        }
      );

      console.log("API Response Data:", response.data);
      console.log("API Response Total_records:", response.data.Total_records);

      if (response.status === 200) {
        setUsers(response.data.data);
        settotalRecords(response.data.Total_records || 0);
      } else {
        setError("Failed to fetch users.");
      }
    } catch (err) {
      console.error("Error fetching users:", err.message);
      setError("Error fetching users. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Add this new useEffect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500); // Delay API call by 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  // Add this new useEffect
  useEffect(() => {
    if (debouncedSearch) {
      handleSearchAPI(debouncedSearch);
    } else {
      fetchUsers("Active", page, itemsPerPage);
    }
  }, [debouncedSearch, page, itemsPerPage]);

  const handleUsers = () => {
    navigate("/users-form");
  };

  const handleArchivedTable = () => {
    navigate("/archived-users"); // Navigate to the archived users page
  };
  const handleDeletePopup = () => {
    setIsDeletePopup(true);
  };

  const handleSort = (key) => {
    // If the same column is clicked again, toggle the direction.
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedRecords = [...users].sort((a, b) => {
      let aValue = a[key];
      let bValue = b[key];

      // Special handling for date fields

      // Compare the values and return the sort order.
      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    // Update the sort configuration and set the sorted clients
    setSortConfig({ key, direction });
    setUsers(sortedRecords);
  };
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  };

  const handleSearchAPI = async (query, status = "Active") => {
    try {
      setLoading(true);

      const response = await axiosInstance.get(
        `/api/search_system_user?page_status=${status}`,
        {
          params: { query, page, per_page: itemsPerPage },
        }
      );

      setUsers(response.data.data || []);
      settotalRecords(response.data.Total_records || 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching search results:", error.message);
      setLoading(false);
    }
  };

  const handleEdit = (user_id) => {
    navigate(`/edit-system-user/${user_id}`);
  };

  const handleArchivedUser = async () => {
    try {
      const response = await axiosInstance.put(`/api/archive_system_user`, {
        ids: selectedFirms,
      });
      if (response.status === 200) {
        await fetchUsers();

        setSelectedFirms([]);
        setSelectAll(false);
      } else {
        alert("Failed to archive firms. Please try again.");
      }
    } catch (error) {
      console.error("Error archiving firms:", error);
      alert("An error occurred while archiving firms.");
    }

    setIsDeletePopup(false);
  };

  const handleCancel = () => {
    window.history.back();
  };

  const handlePaginationChange = (newPage, itemsPerPage) => {
    console.log("Pagination Change - Current Page:", newPage);
    setPage(newPage);
    setItemsPerPage(itemsPerPage);
  };

  return (
    <div
      className={`table-container system-users-page ${isSidebarExpanded ? "expanded" : "collapsed"
        }`}
    >
      <div className="table-container-content system-users-content">
        <div className="table-header">
          {selectedFirms.length > 0 ? (
            <div className="table-header-content archive-header">
              <button className="delete" onClick={handleDeletePopup}>
                Move to Archive
              </button>

              <button
                className="action-header-close-button"
                onClick={() => setSelectedFirms([])}
              >
                <IoCloseOutline className="action-header-close-icon" />
              </button>
            </div>
          ) : (
            <div className="table-header-content">
              <div className="table-left-side">
                <h2 className="jost-bold">System Users</h2>
              </div>
              <div className="table-right-side">
                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search ..."
                    className="search-bar"
                    value={searchQuery}
                    onChange={handleSearch} // Use handleSearch to update search query and fetch data
                  />
                  <IoIosSearch className="search-bar-icon" />
                </div>
                <div className="new-button" onClick={handleUsers}>
                  <span className="new-icon">
                    <LuPlus />
                  </span>
                  <span>New</span>
                </div>
                <button className="system-users-sort-button" onClick={handleSortpopup}>
                  <span className="action-icon custom-action-icon-size">
                    <PiSortAscendingThin />
                  </span>
                </button>
                {isSortPopup && (
                  <div className="sort-popup-container" ref={containerRef}>
                    <div className="sort-popup-header">
                      <span className="sort-title">Sort By</span>
                    </div>
                    <div className="sort-popup-content">
                      <button
                        className="sort-button sort-button-options"
                        onClick={() => handleSort("users_name")}
                      >
                        Name
                      </button>
                      <button
                        className="sort-button sort-button-options"
                        onClick={() => handleSort("users_email")}
                      >
                        Email
                      </button>

                      <button
                        className="sort-button sort-button-options"
                        onClick={() => handleSort("role")}
                      >
                        Role
                      </button>
                    </div>
                    <button
                      className="archive-button"
                      onClick={handleArchivedTable}
                    >
                      Archived System Users
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        {isDeletePopup && (
          <div className="confirm-delete-popup">
            <div className="confirm-delete-popup-content">
              <div className="confirm-model">
                <div className="confirm-model-content">
                  <div className="confirm-model-content-body">
                    <p>Are you sure you want to move to archive?</p>
                  </div>
                  <div className="confirm-model-content-footer">
                    <button
                      className="confirm-delete-button"
                      onClick={handleArchivedUser}
                    >
                      Yes
                    </button>
                    <button
                      className="confirm-cancel-button"
                      onClick={handleCancel}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="data-list-body system-users-data-body">
          <div className="data-list-scroll-body system-users-scroll-body">
            {/* <div className="data-list-table"> */}
              {loading ? (
                <p>Loading...</p>
              ) : error ? (
                <p>{error}</p>
              ) : (
                <>
                  <table className="table multilevel-data system-users-table" style={{ tableLayout: 'fixed', width: '100%' }}>
                    <thead className="sticky-header">
                      <tr className="table-row">
                        <th style={{ width: '5%', textAlign: 'center' }}>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                            disabled={users.length === 0}
                          />
                        </th>
                        <th style={{ width: '8%', textAlign: 'center' }}>Sr. No</th>
                        <th style={{ width: '20%' }}><span style={{
                          textAlign: 'left',
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center'
                        }}>Name</span></th>
                        <th style={{ width: '22%' }}><span style={{
                          textAlign: 'left',
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center'
                        }}>Email</span></th>
                        <th style={{ width: '20%', textAlign: 'center' }}>Phone Number</th>
                        <th style={{ width: '20%', textAlign: 'center' }}>Role</th>
                        <th style={{ width: '10%', textAlign: 'center' }}>Action</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {users.map((user, index) => {
                        const roleName = getRoleName(user.role);

                        return (
                        <tr key={user.id} className="hoverable-row" style={{ verticalAlign: 'middle' }}>
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedFirms.includes(user.user_id)}
                              onChange={() =>
                                handleCheckboxChange(user.user_id)
                              }
                            />
                          </td>
                          <td className="center-align"> {user.serial_number}</td>
                          <td style={{ textAlign: 'left' }}>
                            {user.users_name
                              ? user.users_name
                                .toLowerCase()
                                .split(' ')
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                .join(' ')
                              : "N/A"}
                          </td>
                          <td style={{ textAlign: 'left' }}>{user.users_email}</td>
                          <td className="center-align system-users-phone-cell">{user.contact_number}</td>
                          <td className="center-align">
                            <span
                              className={`value-badge ${getRoleBadgeClass(
                                roleName
                              )}`}
                            >
                              {roleName}
                            </span>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <div className="action-btn">
                              <span
                                className="action-icon"
                                onClick={() => handleEdit(user.user_id)}
                              >
                                <CiEdit color="gray" />
                              </span>
                            </div>
                          </td>
                        </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </>
              )}
            {/* </div> */}
          </div>
          {/* Pagination Component */}
          {!loading && !error && (
            <Pagination
              className="system-users-pagination"
              showPerPage={ITEMS_PER_PAGE}
              total={totalRecords}
              onPaginationChange={handlePaginationChange}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default SystemUsers;
